export const capitalizeFirst = (str) => {
    if (!str) return ''

    return `${str.substring(0, 1).toUpperCase()}${str.substring(1).toLowerCase()}`
}

export const lowerCaseFirst = (str) => {
    if (!str) return ''

    return str.charAt(0).toLowerCase() + str.slice(1)
}



export const capitalizeEachWord = (str) => {
    if (!str) return ''

    return str
        .replace(/([a-z](?=[A-Z]))/g, '$1 ')
        .toLowerCase()
        .split(' ')
        .map((word) => (word ? word[0].toUpperCase() + word.substr(1) : ''))
        .join(' ')
}


export const validateExtraField = (input, required, isNumerical, minLength) => {
    // Check if the string is required and not provided
    if (required && (input === null || input === undefined || input === '')) {
        return false
    } else if ((input === null || input === undefined || input === '')) {
        return true
    }

    // Check if the string is numerical if required
    if (isNumerical && isNaN(input)) {
        return false
    }

    // Check if the string meets the minLength requirement
    if (minLength !== null && input?.length < minLength) {
        return false
    }

    // All validation checks passed
    return true
}

export const trimD1 = (str, n) => {
    const elements = str.split("#")
    const result = elements.slice(0, n).join("#")
    return result
}
